module.exports = __webpack_public_path__ + "img/bg-intro.731dddee.png";